export interface CurrencyMeta {
	id: string;
	prefix: string;
	suffix: string;
	dashboard_precision: number;
	full_precision: number;
	stripe_precision: number;
	stripe_effective_precision: number;
}

const FALLBACK: CurrencyMeta = {
	id: '',
	prefix: '',
	suffix: '',
	dashboard_precision: 0,
	full_precision: 2,
	stripe_precision: 2,
	stripe_effective_precision: 2
};

const registry = new Map<string, CurrencyMeta>();

export const CurrencyRegistry = {
	set(currencies: CurrencyMeta[]): void {
		registry.clear();
		if (!currencies) return;
		for (const c of currencies) {
			if (c && c.id) registry.set(c.id, c);
		}
	},
	get(id: string): CurrencyMeta {
		return registry.get(id) ?? FALLBACK;
	},
	has(id: string): boolean {
		return registry.has(id);
	},
	precision(id: string): number {
		return this.get(id).full_precision;
	},
	round(amount: number, id: string): number {
		const p = this.get(id).full_precision;
		const f = Math.pow(10, p);
		return Math.round(amount * f) / f;
	},
	applyAffix(meta: CurrencyMeta, number: string): string {
		if (number.charAt(0) === '-') {
			return '-' + meta.prefix + number.substring(1) + meta.suffix;
		}
		return meta.prefix + number + meta.suffix;
	}
};
